// import { useEffect, useState, useCallback } from "react";

// import ModalTemplate from "../common/modal/modalTemplate";
// import DivSpinner from "../common/divSpinner";
// import { getUserInfo } from "../storage";

// function CardTokenizing({ show, closeModal, reloadParent = () => {} }) {
//     const userInfo = getUserInfo();
    
//     // State
//     const [showIframe, setShowIframe] = useState(false);
//     const [iframeLoaded, setIframeLoaded] = useState(false);

//     const reset = useCallback(() => {
//         setShowIframe(false);
//         setIframeLoaded(false);
//     }, []);

//     useEffect(() => {
//         // Listen for message from iframe
//         const handleMessage = (event) => {
//             if (event?.data?.status === "SUCCESS_CLOSE_MODAL") {
//                 reloadParent();
//                 reset();
//                 closeModal();
//             }

//             if (event?.data?.status === "CLOSE_MODAL") {
//                 closeModal();
//             }
//         };
//         window.addEventListener("message", handleMessage);
//         return () => window.removeEventListener("message", handleMessage);
//     }, [closeModal, reloadParent, reset]);

//     /**
//      * Body content rendering
//      */
//     const renderBody = () => {
//         return (
//             <>
//                 {!iframeLoaded && <DivSpinner />}
//                 <iframe
//                     id="iframeCardPreAuth"
//                     src={`https://dev.payments.instafix.co.uk/tokenize?id=${userInfo?.customer_id}`}
//                     title="Card Pre-Auth"
//                     width="100%"
//                     height="800"
//                     style={{ display: iframeLoaded ? "block" : "none", border: "none" }}
//                     onLoad={() => setIframeLoaded(true)}
//                 />
//             </>
//         );
//     };

//     return (
//         <ModalTemplate
//             show={show}
//             closeFun={closeModal}
//             size={!showIframe ? "xl" : null}
//             centered
//             title={null}
//             backdrop="static"
//             keyboard={false}
//             body={renderBody()}
//         />
//     );
// }

// export default CardTokenizing;

import { useEffect, useState, useCallback } from "react";

import ModalTemplate from "../common/modal/modalTemplate";
import DivSpinner from "../common/divSpinner";
import { getUserInfo } from "../storage";

function CardTokenizing({ show, closeModal, reloadParent = () => {} }) {
    const userInfo = getUserInfo();

    // Environment
    const paymentApiUrl = process.env.REACT_APP_PAYMENT_SERVER_BASE_URL;

    // State
    const [showIframe, setShowIframe] = useState(false);
    const [iframeLoaded, setIframeLoaded] = useState(false);

    const reset = useCallback(() => {
        setShowIframe(false);
        setIframeLoaded(false);
    }, []);

    useEffect(() => {
        const handleMessage = (event) => {
            if (event?.data?.status === "SUCCESS_CLOSE_MODAL") {
                reloadParent();
                reset();
                closeModal();
            }

            if (event?.data?.status === "CLOSE_MODAL") {
                closeModal();
            }
        };

        window.addEventListener("message", handleMessage);

        return () => {
            window.removeEventListener("message", handleMessage);
        };
    }, [closeModal, reloadParent, reset]);

    const renderBody = () => {
        return (
            <>
                {!iframeLoaded && <DivSpinner />}

                <iframe
                    id="iframeCardPreAuth"
                    src={`${paymentApiUrl}/tokenize?id=${userInfo?.customer_id}`}
                    title="Card Pre-Auth"
                    width="100%"
                    height="800"
                    style={{
                        display: iframeLoaded ? "block" : "none",
                        border: "none",
                    }}
                    onLoad={() => setIframeLoaded(true)}
                />
            </>
        );
    };

    return (
        <ModalTemplate
            show={show}
            closeFun={closeModal}
            size={!showIframe ? "xl" : null}
            centered
            title={null}
            backdrop="static"
            keyboard={false}
            body={renderBody()}
        />
    );
}

export default CardTokenizing;
